module.exports = __webpack_public_path__ + "static/loading.c4e0d321.gif";